module.exports = __webpack_public_path__ + "static/media/q1.3302ecda.png";